// Función para obtener un color cíclico basado en el índice para los graficos de Analitica
// @param index: Número entero que indica la posición actual.

// @return: Retorna un color en formato rgba.
export const getColor = (index) => {
  const opacity = '0.3'
  const colors = [
    `rgba(75,192,192,${opacity})`,    // 1. Aguamarina original
    `rgba(153,102,255,${opacity})`,   // 2. Violeta claro
    `rgba(255,159,64,${opacity})`,     // 3. Naranja suave
    `rgba(255,99,132,${opacity})`,    // 4. Rosa rojizo
    `rgba(54,162,235,${opacity})`,     // 5. Azul medio
    `rgba(255,206,86,${opacity})`,    // 6. Amarillo dorado
    `rgba(201,203,207,${opacity})`,    // 7. Gris claro
    `rgba(100,149,237,${opacity})`,   // 8. Azul cornflower
    `rgba(255,165,0,${opacity})`,      // 9. Naranja vibrante
    `rgba(218,112,214,${opacity})`,   // 10. Orquídea suave
    `rgba(219,112,147,${opacity})`,    // 15. Rosa pálido
    `rgba(147,112,219,${opacity})`,   // 17. Lavanda
    `rgba(244,164,96,${opacity})`,     // 18. Marrón claro (sandy brown)
    `rgba(60,179,113,${opacity})`,    // 19. Verde mar medio (sea green)
    `rgba(158,95,255,${opacity})`,     // 20. Violeta brillante
    `rgba(255,140,0,${opacity})`,      // 21. Naranja intenso claro
    `rgba(65,105,225,${opacity})`,     // 22. Azul real
    `rgba(186,85,211,${opacity})`,    // 23. Orquídea mediano
    `rgba(230,230,250,${opacity})`,   // 24. Lavanda suave
    `rgba(0,191,255,${opacity})`,      // 25. Azul celeste
    `rgba(175,238,238,${opacity})`,    // 27. Turquesa pálido
    `rgba(255,182,193,${opacity})`,    // 28. Rosa claro
    `rgba(255,228,181,${opacity})`,    // 29. Melocotón (moccasin)
    `rgba(176,196,222,${opacity})`,   // 30. Azul acero claro (light steel blue)
    `rgba(255,218,185,${opacity})`,    // 32. Durazno
    `rgba(240,230,140,${opacity})`,    // 33. Caqui
    `rgba(173,216,230,${opacity})`,    // 34. Azul claro
    `rgba(221,160,221,${opacity})`,    // 35. Ciruela (plum)
    `rgba(72,209,204,${opacity})`,     // 36. Turquesa mediano (versión clara)
    `rgba(255,160,122,${opacity})`,    // 37. Salmón claro
    `rgba(102,205,170,${opacity})`,    // 38. Verde mar claro (medium aquamarine)
    `rgba(255,127,80,${opacity})`,    // 39. Coral
    `rgba(255,20,147,${opacity})`,     // 40. Rosa intenso (deep pink)
    `rgba(135,206,250,${opacity})`,   // 41. Azul cielo claro
    `rgba(123, 104, 238, ${opacity})`,   // 42. Azul pizarra mediano
    `rgba(250,128,114,${opacity})`    // 44. Salmón
  ];
  return colors[index % colors.length];
};

// 20 colores 
// rgb(42, 87, 131)  -- rgb(185, 221, 241)
// rgb(158, 61, 34)  -- rgb(255, 198, 133)
// rgb(36, 105, 61)  -- rgb(179, 224, 166)
// rgb(174, 18, 58)  -- rgb(255, 190, 178)
// rgb(124, 77, 121) -- rgb(238, 201, 229)
// rgb(159, 54, 50)  -- rgb(238, 219, 189)
// rgb(73, 82, 94)   -- rgb(213, 213, 213)
// rgb(89, 80, 78)   -- rgb(220, 212, 208)
// rgb(44, 89, 133)  -- rgb(188, 228, 216)
  // const colors = [
  //   'rgba(75,192,192,0.4)',    // 1. Aguamarina original
  //   'rgba(153,102,255,0.45)',   // 2. Violeta claro
  //   'rgba(255,159,64,0.5)',     // 3. Naranja suave
  //   'rgba(255,99,132,0.55)',    // 4. Rosa rojizo
  //   'rgba(54,162,235,0.6)',     // 5. Azul medio
  //   'rgba(255,206,86,0.65)',    // 6. Amarillo dorado
  //   'rgba(201,203,207,0.5)',    // 7. Gris claro
  //   'rgba(100,149,237,0.55)',   // 8. Azul cornflower
  //   'rgba(255,165,0,0.6)',      // 9. Naranja vibrante
  //   'rgba(218,112,214,0.65)',   // 10. Orquídea suave
  //   'rgba(219,112,147,0.7)',    // 15. Rosa pálido
  //   'rgba(147,112,219,0.65)',   // 17. Lavanda
  //   'rgba(244,164,96,0.7)',     // 18. Marrón claro (sandy brown)
  //   'rgba(60,179,113,0.75)',    // 19. Verde mar medio (sea green)
  //   'rgba(158,95,255,0.7)',     // 20. Violeta brillante
  //   'rgba(255,140,0,0.7)',      // 21. Naranja intenso claro
  //   'rgba(65,105,225,0.8)',     // 22. Azul real
  //   'rgba(186,85,211,0.75)',    // 23. Orquídea mediano
  //   'rgba(230,230,250,0.65)',   // 24. Lavanda suave
  //   'rgba(0,191,255,0.8)',      // 25. Azul celeste
  //   'rgba(175,238,238,0.8)',    // 27. Turquesa pálido
  //   'rgba(255,182,193,0.8)',    // 28. Rosa claro
  //   'rgba(255,228,181,0.7)',    // 29. Melocotón (moccasin)
  //   'rgba(176,196,222,0.75)',   // 30. Azul acero claro (light steel blue)
  //   'rgba(255,218,185,0.7)',    // 32. Durazno
  //   'rgba(240,230,140,0.7)',    // 33. Caqui
  //   'rgba(173,216,230,0.8)',    // 34. Azul claro
  //   'rgba(221,160,221,0.8)',    // 35. Ciruela (plum)
  //   'rgba(72,209,204,0.8)',     // 36. Turquesa mediano (versión clara)
  //   'rgba(255,160,122,0.8)',    // 37. Salmón claro
  //   'rgba(102,205,170,0.8)',    // 38. Verde mar claro (medium aquamarine)
  //   'rgba(255,127,80,0.75)',    // 39. Coral
  //   'rgba(255,20,147,0.8)',     // 40. Rosa intenso (deep pink)
  //   'rgba(135,206,250,0.85)',   // 41. Azul cielo claro
  //   'rgba(123, 104, 238, 0.85)',   // 42. Azul pizarra mediano
  //   'rgba(250,128,114,0.85)'    // 44. Salmón
  // ];


// Función para obtener colores por clave de métrica
export const getMetricColor = (key) => {
  const metric = ALL_METRICS.find((m) => m.key === key);
  return metric ? metric.color : '#c3c3c3';
};

// ============================================================================
// Contrato de unidades de Analítica. Los datos provienen de SCAPP (Scapp_analytic_utils):
//   - delivered_food     -> [ton]  (ya convertido desde kg en el backend de SCAPP)
//   - delivered_food_kg  -> [kg]   (si viene disponible)
//   - sfr_value          -> [%] (Porc_entregado)
// Centralizamos aquí el formateo/agregación para no repetir el contrato en
// cada gráfico y evitar dobles conversiones (p. ej. dividir /1000 de nuevo).
// ============================================================================

// Formatea "alimento entregado" para mostrar. El valor YA viene en toneladas
// desde el backend, por lo que NO debe volver a dividirse por 1000.
export const formatDeliveredFoodTon = (ton, { digits = 2, withUnit = true } = {}) => {
  const n = Number(ton);
  const safe = Number.isFinite(n) ? n : 0;
  const text = safe.toFixed(digits);
  return withUnit ? `${text} ton` : text;
};

// Indica si un día tuvo alimentación real (no fue ayuno).
// Un día de ayuno llega con delivered_food = 0 desde el backend.
export const isFedDay = (dayValue) => Number(dayValue?.delivered_food) > 0;

// Umbral por sobre el cual un SFR se considera error de lectura (x10 de la meta).
// Los errores suelen agregar dígitos (x100, x1000), no factores pequeños (x2, x3).
export const SFR_MAX_PLAUSIBLE_PCT = 1000;

// Saneamiento de SFR en el cliente (en SMM la sanitización es SOLO de frontend).
// Un día calculado/persistido puede conservar una lectura errada de SFR; este guard
// la corrige al vuelo para la visualización.
// El SFR puede superar 100% legítimamente (sobre-alimentación); solo se recalcula
// cuando supera SFR_MAX_PLAUSIBLE_PCT y hay meta del día válida (> 0):
//   SFR = (alimento_entregado_kg / meta_del_dia_kg) * 100   (unidades consistentes kg/kg)
// Si tras el recálculo el valor SIGUE por sobre el umbral (p. ej. el kg entregado
// también viene corrupto), o no hay meta para recalcular, el dato es irrecuperable
// y se DESCARTA devolviendo null: un único 2.000.000% ensucia toda la métrica.
// Los consumidores deben tratar null como "ignorar" (no sumar / no graficar).
export const sanitizeSfr = (dayValue) => {
  const reported = Number(dayValue?.sfr_value);
  const sfr = Number.isFinite(reported) ? reported : 0;
  if (sfr <= SFR_MAX_PLAUSIBLE_PCT) return sfr;

  const goal = Number(dayValue?.daily_goal_kg);
  if (Number.isFinite(goal) && goal > 0) {
    // Alimento entregado en kg: usa delivered_food_kg o, en su defecto, delivered_food [ton] * 1000
    let deliveredKg = Number(dayValue?.delivered_food_kg);
    if (!Number.isFinite(deliveredKg)) {
      const ton = Number(dayValue?.delivered_food);
      deliveredKg = Number.isFinite(ton) ? ton * 1000 : 0;
    }
    const recomputed = (deliveredKg / goal) * 100;
    // Si el recálculo quedó dentro de rango plausible, se usa; si no, se descarta.
    if (recomputed <= SFR_MAX_PLAUSIBLE_PCT) return recomputed;
  }

  // Irrecuperable (sin meta válida o recálculo aún implausible): se ignora.
  return null;
};

// Promedio de SFR considerando SOLO días alimentados (excluye ayunos).
// Un día sin alimento (delivered_food = 0) se contabiliza como ayuno y no debe
// diluir el promedio de SFR. Los valores irrecuperables (null) también se ignoran.
// summary: [{ value: { sfr_value, delivered_food } }, ...]
export const averageSfrFed = (summary = []) => {
  let sum = 0;
  let count = 0;
  (summary || []).forEach((item) => {
    const value = item?.value ?? {};
    if (!isFedDay(value)) return;
    const sfr = sanitizeSfr(value);
    if (Number.isFinite(sfr)) { // null (SFR irrecuperable) se ignora
      sum += sfr;
      count += 1;
    }
  });
  return count > 0 ? sum / count : 0;
};



export const ALL_METRICS = [
  { key: "delivered_food",   label: "Alimento entregado",   color:"rgba(125, 196, 232, 0.8)", inactiveColor:"rgba(125, 196, 232, 0.2)", vsMetrics:true  },
  { key: "sfr_value",        label: "SFR",                  color:"rgba(232, 94, 48, 0.8)"  , inactiveColor:"rgba(232, 94, 48, 0.2)"  , vsMetrics:true  },
  { key: "alarms_count",     label: "Alarmas",              color:"rgba(255, 204, 102, 0.8)", inactiveColor:"rgba(255, 204, 102, 0.2)", vsMetrics:true  },
  { key: "perdidos_count",   label: "PPA",                  color:"rgba(255, 102, 102, 0.8)", inactiveColor:"rgba(255, 102, 102, 0.2)", vsMetrics:true  },
  { key: "visitas_count",    label: "Visitas",              color:"rgba(102, 255, 178, 0.8)", inactiveColor:"rgba(102, 255, 178, 0.2)", vsMetrics:true  },
  { key: "alarms_by_ton",    label: "Alarmas / Ton",        color:"rgba(205, 126, 206, 0.8)", inactiveColor:"rgba(205, 126, 206, 0.2)", vsMetrics:false },
  { key: "alarms_by_visits", label: "Alarmas / Visitas",    color:"rgba(205, 126, 206, 0.8)", inactiveColor:"rgba(205, 126, 206, 0.2)", vsMetrics:false },
];